export const GET_PROMOS = "GET_PROMOS";
export const SHOW_PROMOS = "SHOW_PROMOS";
export const SET_STATE = "PROMOS_STATE";
export const GET_PROMOTION_BANNERS = "GET_PROMOTION_BANNERS";